<template>
  <apexchart
    :ref="refChart"
    type="bar"
    height="350"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
  export default {
    props: {
      series: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: "",
      },
      refChart: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        options: {
          chart: {
            type: "bar",
            height: 350,
            width: '100%',
            stacked: true,
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: "end", // 'around', 'end'
              borderRadiusWhenStacked: "last", // 'all', 'last'
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: "13px",
                    fontWeight: 900,
                  },
                },
              },
            },
          },
          xaxis: {
            categories: [],
          },
          legend: {
            position: "right",
            offsetY: 40,
          },
          fill: {
            opacity: 1,
          },
        },
      }
    },
    watch: {
      series() {
        const me = this;
        me.updateChart();
      },
      categories() {
        const me = this;
        me.updateChart();
      },
    },
    methods: {
      updateChart() {
        const me = this;
        const chart = me.$refs[me.refChart];
        chart.updateOptions({
          xaxis: {
            categories: me.categories,
          },
        });
        chart.updateSeries(me.series);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>